






















































































































































































































import { Component, Vue } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import GenericEdit from "@/core/Generics/GenericEdit";
import ResearchCenter from "@/models/research/ResearchCenter/reseachCenter.model";
import BaseSelectPerson from "@/components/base/baseSelectPerson/baseSelectPerson.vue";
import { InstitutionType } from "@/enums/InstitutionType";

@Component({
  components: {
    BaseSelectPerson,
  },
})
export default class ResearchCenterEdit extends GenericEdit<ResearchCenter> {
  constructor() {
    super();
    this.controller = "ResearchCenters";
    this.model = new ResearchCenter();
  }

  image = "";
  imageResult: any = null;
  institutionType = InstitutionType;

  protected async getData() {
    try {
      if (this.modelToEdit && !this.loadFromAPI)
        this.model = this.map<ResearchCenter>(this.modelToEdit);
      else {
        this.loading = true;
        this.model = await this.repository.byId(this.id, this.include);
      }
      this.image = this.model.image;
      this.model.image = [];

      this.modelInit = this.map<ResearchCenter>(this.model);
    } catch (errors) {
      this.operationFailedErrors(errors);
    } finally {
      this.loading = false;
    }
  }

  get getImage() {
    if (this.imageResult) return this.imageResult;
    if (this.image) return `data:image/jpg;base64, ${this.image}`;

    return false;
  }

  changeImage() {
    var self = this;
    var reader = new FileReader();
    reader.readAsArrayBuffer(this.model.file);
    this.imageResult = URL.createObjectURL(this.model.file);
    reader.onloadend = function (evt: any) {
      if (evt.target.readyState == FileReader.DONE) {
        var arrayBuffer = evt.target.result,
          array = new Uint8Array(arrayBuffer);
        for (var i = 0; i < array.length; i++) {
          self.model.image.push(array[i]);
        }
      }
    };
  }

  protected clean() {
    setTimeout(() => this.$validator.errors.clear(), 10);
    this.model = this.map<ResearchCenter>(this.modelInit);
    this.imageResult = null;
  }
}
